import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchAppToken } from '../actions/app_token'
import Toastr from '../components/toastr';
import { Button, Form, Grid, Header, Segment, Divider } from 'semantic-ui-react'
import '../App.css';
import { Link } from 'react-router-dom'
import { SYSTEM_TITLE } from '../constants'

class Login extends Component {
  constructor(props){
    super(props);
    this.state = {
      username: '',
      password: '',
      messageShown: true,
      messageTimer: null
    }
  }

  dismissMessage() {
    this.setState({
      messageShown: false
    })
  }

  showMessage() {
    clearTimeout(this.state.messageTimer);
    this.state.messageTimer = setTimeout(() => {
      this.dismissMessage();
    }, 6000);

    if (this.state.messageShown && this.props.loginFailure) {
      return <Toastr messageBody="Invalid Email or Password" messageType="red" dismiss={ this.dismissMessage.bind(this) }/>
    }
    return null;
  }

  //Set the messageShown state to TRUE before the props are updated
  componentWillReceiveProps(){
    this.setState({
      messageShown: true
    })
  }

  render(props) {
    return (
      <div>
        <header className="App-header">
          <h1 className="App-title">{SYSTEM_TITLE}</h1>
        </header>
        <div className='login-form'>
          { this.props.loginFailure && this.showMessage() }
          <Grid
            textAlign='center'
            style={{ height: '100%' }}
            verticalAlign='middle'
          >
            <Grid.Column style={{ maxWidth: 450 }}>
              <Header as='h2' color='teal' textAlign='center'>
                Log-in to your account
              </Header>
              <Form size='large'>
                <Segment>
                  <Form.Input
                    fluid
                    icon='user'
                    iconPosition='left'
                    placeholder='E-mail address'
                    type='username'
                    onChange={event => this.setState({username: event.target.value})}
                  />
                  <Form.Input
                    fluid
                    icon='lock'
                    iconPosition='left'
                    placeholder='Password'
                    type='password'
                    onChange={event => this.setState({password: event.target.value})}
                  />
                  <Button loading={this.props.pending} color='teal' fluid size='large' onClick={() => this.props.login(this.state)}>Login</Button>
                  <Divider />
                  <Link to='/password_reset'>Forgot password?</Link>
                </Segment>
              </Form>
            </Grid.Column>
          </Grid>
        </div>
      </div>

    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.app_token.accessToken,
    loading: state.app_token.loading,
    loginSuccess: state.app_token.loginSuccess,
    loginFailure: state.app_token.loginFailure,
    pending: state.app_token.pending,
    signedIn: state.app_token.signedIn
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    login: (localState) => {
      var { username, password, grant_type } = localState;
      dispatch(fetchAppToken({username, password, grant_type }))
    },

  }
}

let LoginPage = connect(mapStateToProps, mapDispatchToProps)(Login)
export default LoginPage;



// WEBPACK FOOTER //
// ./src/views/login.js